/**
 * EIN validation/normalization for org settings + onboarding (NOS-167).
 * Mirrors supabase/functions/_shared/receiptIdentity.ts (Deno and web can't
 * share a module) — keep the two in sync.
 */

export const EIN_REGEX = /^\d{2}-?\d{7}$/

/** Normalizes an EIN to XX-XXXXXXX; returns null when invalid or empty. */
export function normalizeEin(input: string | null | undefined): string | null {
  const raw = input?.trim() ?? ""
  if (!EIN_REGEX.test(raw)) return null
  const digits = raw.replace("-", "")
  return `${digits.slice(0, 2)}-${digits.slice(2)}`
}

/** Empty is fine (EIN optional); non-empty must match the EIN format. */
export function validateEinInput(input: string): { valid: boolean; error?: string } {
  if (!input.trim()) return { valid: true }
  if (!EIN_REGEX.test(input.trim())) {
    return { valid: false, error: "EIN must be 9 digits (XX-XXXXXXX)" }
  }
  return { valid: true }
}
